import { render } from "./PurchaseLoginOrRegister.vue?vue&type=template&id=7f6c2cd4&scoped=true&ts=true"
import script from "./PurchaseLoginOrRegister.vue?vue&type=script&lang=ts"
export * from "./PurchaseLoginOrRegister.vue?vue&type=script&lang=ts"

import "./PurchaseLoginOrRegister.vue?vue&type=style&index=0&id=7f6c2cd4&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6c2cd4"]])

export default __exports__